import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
const resultFunction = (activeWalletAccount, isLedger) => isLedger(activeWalletAccount);
const isLedgerActiveSelector = defineSelectorResultFunction({
    id: 'isLedgerActive',
    resultFunction,
    dependencies: [
        { selector: 'active' },
        { selector: 'isLedger' },
    ],
});
export default isLedgerActiveSelector;
